import React from 'react';

const CartIcon = ({ 
  size = 24,
  color = "currentColor",
  strokeWidth = 1.5,
  className = "",
  ...props 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.5 7.67001V6.70001C7.5 4.45001 9.31 2.24001 11.56 2.03001C14.24 1.77001 16.5 3.88001 16.5 6.51001V7.89001"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00007 22H15.0001C19.0201 22 19.7401 20.39 19.9501 18.43L20.7001 12.43C20.9701 9.99 20.2701 8 16.0001 8H8.00007C3.73007 8 3.03007 9.99 3.30007 12.43L4.05007 18.43C4.26007 20.39 4.98007 22 9.00007 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4955 12H15.5045H15.4955Z"
        fill={color}
      />
      <path
        d="M15.4955 12H15.5045"
        stroke={color}
        strokeWidth={strokeWidth * 1.333} // Convert 2 to relative stroke width
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.49451 12H8.50349"
        stroke={color}
        strokeWidth={strokeWidth * 1.333} // Convert 2 to relative stroke width
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CartIcon;